// src/pages/AcceptInvite.tsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function AcceptInvite() {
  const q = useQuery();
  const navigate = useNavigate();
  const [msg, setMsg] = useState("Finishing invite…");
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const campaign_id = q.get("campaign_id");
        const role = q.get("role") || "volunteer";
        if (!campaign_id) throw new Error("Missing campaign_id");

        const { data: auth } = await supabase.auth.getUser();
        const user = auth.user;
        if (!user) throw new Error("Not signed in.");

        // Try the upsert (insert or update role + invitation_status)
        const { error: upsertErr } = await supabase
          .from("campaign_users")
          .upsert(
            {
              campaign_id,
              user_id: user.id,
              role,
              invitation_status: "accepted",
            },
            { onConflict: "campaign_id,user_id" }
          );
        if (upsertErr) throw upsertErr;

        // Mark invite accepted (best-effort)
        if (user.email) {
          await supabase
            .from("campaign_invites")
            .update({ status: "accepted" })
            .eq("campaign_id", campaign_id)
            .eq("email", user.email.toLowerCase())
            .eq("status", "pending");
        }

        setMsg("Invite accepted. Taking you to the campaign…");
        navigate(`/campaigns/${campaign_id}`, { replace: true });
      } catch (e: any) {
        // Show full message so we can debug RLS quickly
        setErr(e?.message ? String(e.message) : String(e));
      }
    })();
  }, [navigate]);

  return (
    <div style={{ maxWidth: 520, margin: "60px auto", padding: 16 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700 }}>Accepting Invite</h1>
      {err ? (
        <div style={{ marginTop: 12, color: "#b91c1c", whiteSpace: "pre-wrap" }}>
          {err}
        </div>
      ) : (
        <div style={{ marginTop: 12 }}>{msg}</div>
      )}
    </div>
  );
}
